import React from "react";
import styles from "./scrollable-table.module.scss";
import {TableCell} from "../table/table-cell";
import classNames from "classnames"
import {AthleteStatsModuleBadgeLogo} from "../../../widgets/athlete-widget/modules/athlete-stats-related-games-module/components/related-game/athlete-stats-module.badge-logo";

export const ScrollableTableTextCell = ({cell, hasBorder, num, extraClassName, isUsLayout}) => {
  const cellProps = {
    colSpan: num,
    className: classNames(
      styles.table_text_cell,
      {[styles.table_text_major_cell]: cell.isMajor},
      {[styles.table_text_bold_cell]: cell.isBold},
      {[styles.table_cell_border]: hasBorder},
      extraClassName
    )
  }

  const badgeProps = {
    stat: cell,
    shouldRenderBadge: cell.logo && !isUsLayout
  }

  return (
    <TableCell {...cellProps}>
      {
        cell.logo && !isUsLayout ? <bdi>
          <AthleteStatsModuleBadgeLogo {...badgeProps}/>
        </bdi> : <bdi>{`${cell.value}`}</bdi>
      }
    </TableCell>
  )
}